document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-ttx-load]");
  if (!btn) return;

  const root = btn.closest("[data-ttx]");
  if (!root) return;

  const tpl = root.querySelector("template[data-ttx-template]");
  if (!tpl) return;

  // Placeholder weg
  const ph = root.querySelector(".ttx-embed__placeholder");
  if (ph) ph.remove();

  // Iframe rein
  root.appendChild(tpl.content.cloneNode(true));
});
